export const handleCreditCardNumberChange = (realChangeFn: Function, e) => {
  let value = e.target.value.replace(/\D/g, '');

  if (value.length > 16) {
    return;
  }

  const formattedValue = formatCreditCardNumber(value);

  realChangeFn(formattedValue);
};

export const handleCreditCardNumberKeyDown = (realChangeFn: Function, e) => {
  if (e.key === 'Backspace') {
    let value = (e.target.value || '').replace(/\D/g, '');

    if (value.length === 0) {
      return;
    }

    value = value.slice(0, -1);

    const formattedValue = formatCreditCardNumber(value);

    realChangeFn(formattedValue);
    e.preventDefault();
  }
};

export const handleNumberDigitChange = (realChangeFn: Function, e, max) => {
  let value = e.target.value.replace(/\D/g, '');

  if (value.length > max) {
    return;
  }

  const formattedValue = formatCreditCardNumber(value);

  realChangeFn(formattedValue);
};

export const handleNumberKeyDown = (realChangeFn: Function, e) => {
  if (e.key === 'Backspace') {
    let value = (e.target.value || '').replace(/\D/g, '');

    if (value.length === 0) {
      return;
    }

    value = value.slice(0, -1);

    const formattedValue = formatCreditCardNumber(value);

    realChangeFn(formattedValue);
    e.preventDefault();
  }
};

export function formatCreditCardNumber(value: string): string {
  return value.replace(/.{4}(?=.)/g, '$& ');
}
